var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeEyeSizemWeightfilled = function SvgTypeEyeSizemWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M23.185 11.696c-.032-.074-.827-1.835-2.592-3.6C18.241 5.742 15.27 4.5 12 4.5S5.76 5.743 3.407 8.095C1.642 9.861.844 11.625.815 11.696a.75.75 0 0 0 0 .61c.032.074.827 1.834 2.592 3.6C5.759 18.256 8.73 19.5 12 19.5s6.24-1.243 8.593-3.594c1.765-1.766 2.56-3.526 2.592-3.6a.75.75 0 0 0 0-.61M12 15.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5"
  })));
};
export default SvgTypeEyeSizemWeightfilled;